/*
 * ce-sticky-atc.js — Casper-ecom sticky add-to-cart bar (product page)
 *
 * WHY JS (see DAWN-SKILL/reference/00-quality-rules.md §4): the bar must appear exactly when the real
 * add-to-cart button leaves the viewport and disappear when it comes back — a visibility relation CSS
 * cannot express. Cost: one IntersectionObserver on `.product-form__buttons`, no scroll listener, one
 * pubsub subscription to keep the mirrored price in sync. Loaded with `defer` by main-product.liquid
 * only when the section setting `ce_sticky_atc` is on.
 *
 * Contract: the bar never submits a second form — its button clicks Dawn's real submit
 * (`#ProductSubmitButton-<section id>`), so product-form.js keeps owning the add-to-cart flow.
 */
if (!customElements.get('ce-sticky-atc')) {
  customElements.define(
    'ce-sticky-atc',
    class CeStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.button = this.querySelector('.ce-sticky-atc__button');
        this.label = this.querySelector('.ce-sticky-atc__label');
        this.price = this.querySelector('.ce-sticky-atc__price');
        this.target = document.querySelector(`#ProductSubmitButton-${this.sectionId}`);
        if (!this.target) return;

        this.button.addEventListener('click', () => {
          if (this.target.hasAttribute('disabled') || this.target.getAttribute('aria-disabled') === 'true') return;
          this.target.click();
        });

        this.syncState();
        // The root is extended far below the viewport, so "not intersecting" means exactly
        // "the real button is entirely ABOVE the viewport" — the state changes only when it
        // crosses the top edge, which fires reliably even on fast/jump scrolls (a plain
        // threshold 0 observer misses a jump from "below" to "above": ratio 0 → 0, no callback).
        this.observer = new IntersectionObserver(
          (entries) => {
            this.classList.toggle('is-visible', !entries[0].isIntersecting);
          },
          { rootMargin: '0px 0px 100000px 0px', threshold: 0 }
        );
        this.observer.observe(this.target.closest('.product-form__buttons') || this.target);

        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => this.syncState());
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribe?.();
      }

      syncState() {
        // mirror label + disabled state from Dawn's button, and the price from the price block
        const targetLabel = this.target.querySelector('span');
        if (targetLabel && this.label) this.label.textContent = targetLabel.textContent.trim();
        const disabled = this.target.hasAttribute('disabled');
        this.button.toggleAttribute('disabled', disabled);
        if (this.price) {
          const priceEl = document.querySelector(`#price-${this.sectionId} .price__sale .price-item--sale, #price-${this.sectionId} .price__regular .price-item--regular`);
          if (priceEl) this.price.textContent = priceEl.textContent.trim();
        }
      }
    }
  );
}
